/**
 * Textos del Catàleg (`en`): ajunta els fitxers de cada tall. Cablejat a `en.ts` amb un sol
 * `...catalegEn`; així cada tall edita només el seu fitxer.
 */

import { supplierArticlesEn } from './supplierArticles.en.js';
import { ftRequestEn } from './ftRequest.en.js';
import { articleRestrictionsEn } from './articleRestrictions.en.js';

export const catalegEn = {
  ...supplierArticlesEn,
  ...ftRequestEn,
  ...articleRestrictionsEn,
} as const;
